import { createUseStyles } from 'react-jss'

export default createUseStyles({
  previewContainer: {
    marginTop: 20,
    marginBottom: 20
  },
  mediaPreview: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: 300,
    margin: '0 auto'
  }
})
